module.exports = __webpack_public_path__ + "img/jhsph.4aa66ca5.jpg";